export default "__VITE_ASSET__6b87d0a1__"